module.exports = __webpack_public_path__ + "static/img/95-1.0cb5acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/95-1.jpg
// module id = RYik
// module chunks = 0